import { render, staticRenderFns } from "./UnsupportCheck.vue?vue&type=template&id=031887ea&scoped=true&"
import script from "./UnsupportCheck.vue?vue&type=script&lang=ts&"
export * from "./UnsupportCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031887ea",
  null
  
)

export default component.exports